import React from "react";
import { Box, Typography } from "@mui/material";

// index.scss forces every outlined input border transparent and every
// MuiInputBase-root to 44px; both are restated so the boxes read as boxes.
export const inputSx = {
  backgroundColor: "#ffffff",
  "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D0D5DD !important",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#98A2B3 !important",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1E3A5F !important",
    borderWidth: "2px !important",
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: "#B42318 !important",
  },
  "& .MuiOutlinedInput-root.Mui-disabled": { backgroundColor: "#F9FAFB" },
  "& .MuiInputBase-multiline": { height: "auto !important", padding: "10px 12px !important" },
  "& .MuiFormHelperText-root": { marginLeft: 0, marginRight: 0, fontSize: "11.5px" },
};

export const navyButtonSx = {
  height: 36,
  px: 2.25,
  borderRadius: "8px",
  textTransform: "none",
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 500,
  color: "#ffffff",
  backgroundColor: "#1E3A5F",
  boxShadow: "none",
  "&:hover": { backgroundColor: "#2E5A8F", boxShadow: "none" },
  "&.Mui-disabled": { color: "#ffffff", backgroundColor: "#98A2B3" },
};

export const outlinedButtonSx = {
  height: 36,
  px: 2,
  borderRadius: "8px",
  textTransform: "none",
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 500,
  color: "#344054",
  borderColor: "#D0D5DD",
  "&:hover": { borderColor: "#1E3A5F", backgroundColor: "#F2F4F7" },
};

export const FieldLabel = ({ htmlFor, id, required, optional, children }) => (
  <Typography
    component="label"
    htmlFor={htmlFor}
    id={id}
    sx={{ display: "block", mb: 0.5, fontFamily: "Inter", fontSize: "12.5px", fontWeight: 500, color: "#344054" }}
  >
    {children}
    {required && (
      <Box component="span" aria-hidden="true" sx={{ color: "#B42318", ml: 0.25 }}>
        *
      </Box>
    )}
    {optional && (
      <Box component="span" sx={{ color: "#667085", fontWeight: 400, ml: 0.5 }}>
        (optional)
      </Box>
    )}
  </Typography>
);

export const StatePanel = ({ icon, title, text, action }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: 0.75,
      px: 2,
      py: 5,
    }}
  >
    <Box
      sx={{
        width: 48,
        height: 48,
        mb: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: "#F2F4F7",
        color: "#1E3A5F",
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ fontFamily: "Inter", fontWeight: 600, fontSize: "14px", color: "#101828" }}>
      {title}
    </Typography>
    {text && (
      <Typography sx={{ maxWidth: 440, fontFamily: "Inter", fontSize: "12.5px", color: "#667085" }}>
        {text}
      </Typography>
    )}
    {action}
  </Box>
);
